<template>
  <div class="wrapper">
    <BPMNNodeBase :item="item" @updateName="updateName"/>
    <div class="form-group m-2">
      <label>Mitarbeiter/Vertreter</label>
      <select v-model="assignee" id="usertaskassignee" @change="updateUser" class="form-control">
        <option value=""></option>
        <option v-for="u in users" :key="u.id" :value="u.userKey">{{ u.firstname }} {{ u.lastname }} (M{{u.userKey}})</option>
        <option v-for="u in handusers" :key="u.id" :value="'ihand_' + u.handid">{{ u.firstname }} {{ u.lastname }} (V{{u.id}})</option>
      </select>
    </div>
    <div class="row m-2">
      <button @click="openForm" class="form-control btn btn-primary">Formular bearbeiten</button>
    </div>
  </div>
</template>

<script>
import xmlutil from '@/modules/xmlutil.js'
import sysuser from '@/modules/sysuser.js'
import ihanduser from '@/modules/ihanduser.js'
import BPMNNodeBase from './BPMNNodeBase.vue'

export default {
  name: 'BPMNUserTask',
  props: ['item'],
  components: {
    BPMNNodeBase
  },
  data() {
    return {
      users: [],
      handusers: [],
      assignee: '',
      formKey: '',
    }
  },
  watch: {
    item() {
      this.updateView();
    }
  },
  mounted: function() {
    this.fetchData();
  },
  methods: {
    updateName(e) {
      this.$emit('updateName',e);
    },
    updateUser(u) {
      console.log('update user',this.assignee,this.item,u);
      var attr = xmlutil.jsonxmlattr(this.item,'http://activiti.org/bpmn','assignee');
      console.log('attr found?',attr,u.target.value,this.assignee);
      if (attr) {
        attr.value = this.assignee;
      } else {
        console.log('warning no assignee attribute found');
      }
    },
    updateView() {
      var attr = xmlutil.jsonxmlattr(this.item,'http://activiti.org/bpmn','assignee');
      if (attr) {
        console.log('update show assignee',attr.value);
        this.assignee = attr.value;
      }
    },
    fetchData()  {
      var self = this;
      sysuser.list(function(data) {
        self.users = data;
      })
      ihanduser.list(function(data) {
        self.handusers = data.rows;
        self.updateView();
      })

    },
    openForm() {
      //this.$bvModal.show('userFormDlg');
      this.$emit('formOpen');
    }
  }
}
</script>
